import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, groupsDataAtom } from '../groups_list_atoms';
import { GroupsDataHook } from '../groups_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useGroupsData = (): GroupsDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(groupsDataAtom);

    const { items } = useTableData({
        view,
        filters,
        stats,
        data,
        setStats,
    });

    return { items };
};
